<template>
  <div class="content-wrapper">
    <app-breadcrumb
      :page-title="$t('Unificación de Proceso')"
      :directory="$t('Listado')"
      :icon="'trello'"
    />
    <div class="row">
      <div class="col-sm-12 col-md-12">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow mb-3"
            @click="
              () => {
                $hub.$emit('reload-' + tableId);
              }
            "
          >
            <i data-feather="refresh-ccw" class="pr-2" /> Refrescar
          </button>
        </div>
      </div>
    </div>
    
    <app-table :id="tableId" :options="options" @action="getListAction" />

    <process-unification-modal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :all-process="rowData"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../apiUrl";
import { TableHelpers } from "./TableHelpers";

export default {
  extends: CoreLibrary,
  mixins: [TableHelpers],
  data() {
    return {
      tableId: "process-unification-table",
      isAddEditModalActive: false,
      rowData: {},
      options: {
        name: "process-unification-table",
        url: `/accreditationtechnical/processUnifications/index`,
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
          },
        ],
        showFilter: true,
        showSearch: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.data();
  },
  methods: {
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `/accreditationtechnical/processUnifications/${this.rowData.id}`;
        this.openAddEditModal();
      }
    },
    data() {},
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#modal-add-edit").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
  },

}
</script>

<style>

</style>